module.exports = __webpack_public_path__ + "logo-orkla-tagline-es-1db4cc1147a2a5206bcb91330b94e525.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-es.svg
// module id = 63
// module chunks = 0